"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Sync_1 = require("@twii/core-ui-fabric/lib/component/Sync");
var ListingReview_1 = require("./ListingReview");
var ListingReviewList_classNames_1 = require("./ListingReviewList.classNames");
var ListingReviewList_styles_1 = require("./ListingReviewList.styles");
var ListingReviewForm_1 = require("./ListingReviewForm");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var UserContainer_1 = require("../../user/component/UserContainer");
var ListingReviewListItems = /** @class */ (function (_super) {
    __extends(ListingReviewListItems, _super);
    function ListingReviewListItems() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingReviewListItems.prototype.render = function () {
        var items = this.props.reviewList.itemsView.map(function (item) {
            return React.createElement(ListingReview_1.ListingReview, { key: item.id, className: "listing-review-list-item", review: item });
        });
        return (React.createElement("div", { className: this.props.className }, items));
    };
    ListingReviewListItems = __decorate([
        mobx_react_1.observer
    ], ListingReviewListItems);
    return ListingReviewListItems;
}(React.Component));
var ListingReviewAdd = /** @class */ (function (_super) {
    __extends(ListingReviewAdd, _super);
    function ListingReviewAdd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onCancel = function () {
            _this.props.reviewList.cancelEdit();
        };
        _this._onAfterSave = function () {
            _this.props.reviewList.refresh();
        };
        _this._onClickAdd = function () {
            _this.props.reviewList.add();
        };
        return _this;
    }
    ListingReviewAdd.prototype.render = function () {
        var content;
        if (this.props.reviewList.newReview) {
            content = React.createElement(ListingReviewForm_1.ListingReviewForm, { review: this.props.reviewList.newReview, onCancel: this._onCancel, onAfterSave: this._onAfterSave });
        }
        else {
            content = React.createElement(Button_1.DefaultButton, { onClick: this._onClickAdd, iconProps: { iconName: "Add" } }, "Add Review");
        }
        return (React.createElement("div", { className: this.props.className }, content));
    };
    ListingReviewAdd = __decorate([
        mobx_react_1.observer
    ], ListingReviewAdd);
    return ListingReviewAdd;
}(React.Component));
var ListingReviewAddContainer = /** @class */ (function (_super) {
    __extends(ListingReviewAddContainer, _super);
    function ListingReviewAddContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderUser = function (userProfile) {
            var existing = _this.props.reviewList.items.find(function (item) {
                return item.author && item.author.id === userProfile.id;
            });
            if (!existing) {
                return React.createElement(ListingReviewAdd, __assign({}, _this.props));
            }
            return null;
        };
        return _this;
    }
    ListingReviewAddContainer.prototype.render = function () {
        return React.createElement(UserContainer_1.UserContainer, { onRenderUser: this._onRenderUser });
    };
    return ListingReviewAddContainer;
}(React.Component));
var ListingReviewSummary = /** @class */ (function (_super) {
    __extends(ListingReviewSummary, _super);
    function ListingReviewSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingReviewSummary.prototype.render = function () {
        var listing = this.props.reviewList.listing;
        if (listing && listing.total_reviews > 0) {
            var totals = [listing.total_rate1, listing.total_rate2, listing.total_rate3, listing.total_rate4, listing.total_rate5];
            var max = totals.reduce(function (prev, current) {
                return current > prev ? current : prev;
            });
            return (React.createElement("div", { style: { margin: 8, width: 300 } },
                React.createElement("div", null,
                    React.createElement("div", { className: "total_rate_5", title: listing.total_rate5 + " rated 5", style: { width: ((listing.total_rate5 / max) || 0.01) * 100 + "%", height: 12, backgroundColor: "#107c10" } }),
                    React.createElement("div", { className: "total_rate_4", title: listing.total_rate4 + " rated 4", style: { width: ((listing.total_rate4 / max) || 0.01) * 100 + "%", height: 12, backgroundColor: "#bad80a" } }),
                    React.createElement("div", { className: "total_rate_3", title: listing.total_rate3 + " rated 3", style: { width: ((listing.total_rate3 / max) || 0.01) * 100 + "%", height: 12, backgroundColor: "#ffb900" } }),
                    React.createElement("div", { className: "total_rate_2", title: listing.total_rate2 + " rated 2", style: { width: ((listing.total_rate2 / max) || 0.01) * 100 + "%", height: 12, backgroundColor: "#ea4300" } }),
                    React.createElement("div", { className: "total_rate_1", title: listing.total_rate1 + " rated 1", style: { width: ((listing.total_rate1 / max) || 0.01) * 100 + "%", height: 12, backgroundColor: "#a80000" } }))));
        }
        return null;
    };
    ListingReviewSummary = __decorate([
        mobx_react_1.observer
    ], ListingReviewSummary);
    return ListingReviewSummary;
}(React.Component));
var ListingReviewList = /** @class */ (function (_super) {
    __extends(ListingReviewList, _super);
    function ListingReviewList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingReviewList.prototype.render = function () {
        var classNames = ListingReviewList_classNames_1.getClassNames(ListingReviewList_styles_1.getStyles(undefined, this.props.styles), this.props.className);
        return (React.createElement("div", { className: classNames.root },
            React.createElement(ListingReviewAddContainer, __assign({}, this.props, { className: classNames.addContainer })),
            React.createElement(ListingReviewListItems, __assign({}, this.props, { className: classNames.items }))));
    };
    return ListingReviewList;
}(React.Component));
exports.ListingReviewList = ListingReviewList;
var ListingReviewListContainer = /** @class */ (function (_super) {
    __extends(ListingReviewListContainer, _super);
    function ListingReviewListContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderDone = function () {
            return React.createElement(ListingReviewList, __assign({}, _this.props));
        };
        return _this;
    }
    ListingReviewListContainer.prototype.componentWillMount = function () {
        this.props.reviewList.load();
    };
    ListingReviewListContainer.prototype.render = function () {
        return React.createElement(Sync_1.Sync, { sync: this.props.reviewList.sync, onRenderDone: this._onRenderDone, syncLabel: "Loading Reviews..." });
    };
    return ListingReviewListContainer;
}(React.Component));
exports.ListingReviewListContainer = ListingReviewListContainer;
